<template>
  <div
    class="doctor-list-main-wrapper cbg-white-container input-container theme--light v-card p-16 border-card"
  >
    <CRow>
      <CCol sm="12">
        <CRow>
          <CCol md="3" sm="6">
            <div class="common-search position-relative">
              <CInput label="Search by Name" v-model="search" placeholder="Name" />
              <div
                v-if="search !== ''"
                class="cross-svg center-cross-svg position-absolute"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </CCol>
          <CCol sm="6" md="2">
            <label for>Per Page</label>
            <v-select v-model="recordPerPage" :items="perPageOptions" outlined hide-details />
          </CCol>
          <CCol md="3" sm="6">
            <label for>Test Type</label>
            <v-select v-model="type" :items="searchTestTypeOptions" outlined hide-details />
          </CCol>
          <v-col cols="12" md="2" sm="3">
            <label class="col-sm-12 mb-0 d-none-mob1"></label>
            <v-btn class="btn btn-primary mr-4" @click="getMasterTest()">Search</v-btn>
          </v-col>
          <v-col
            v-if="permissions.includes('CAN_ADD_DOCSMART_TESTS_MASTER')"
            cols="12"
            md="2"
            sm="3"
            class
          >
            <label class="col-sm-12 mb-0 d-none-mob1"></label>
            <v-btn class="btn btn-primary mr-4" @click="addTestModal">Add Test</v-btn>
          </v-col>
        </CRow>
      </CCol>
      <CCol sm="12" class="overflow-auto">
        <table class="table userlistTable small-table-width">
          <thead>
            <tr class="table-success">
              <th scope="col">Name</th>
              <th scope="col">Type</th>
              <th scope="col">Category</th>
              <th scope="col">Home Service</th>
              <th scope="col">Report By Day</th>
              <th scope="col">Fasting</th>
              <th scope="col">Advice</th>
              <th scope="col">Sub Type</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="test in masterTest" :key="test.id">
              <td class="w-20">{{ test.name }}</td>
              <td>{{ test.type }}</td>
              <td>{{ test.category }}</td>
              <td>{{ test.home_service ? "Yes" : "No" }}</td>
              <td>{{ test.report_by_day }}</td>
              <td>{{ test.fasting ? "Yes" : "No" }}</td>
              <td>{{ test.advice ? test.advice : "N/A" }}</td>
              <td>{{ test.sub_type ? test.sub_type : "N/A" }}</td>
              <td>
                <CRow style="flex-wrap: nowrap">
                  <CButton
                    variant="outline"
                    color="success"
                    @click="editTestModal(test), (action = 'Edit')"
                    v-if="
                      permissions.includes('CAN_EDIT_DOCSMART_TESTS_MASTER')
                    "
                  >Edit</CButton>
                  <CButton
                    variant="outline"
                    color="danger"
                    @click="deleteTestModal(test)"
                    v-if="
                      permissions.includes('CAN_DELETE_DOCSMART_TESTS_MASTER')
                    "
                    class="ml-2"
                  >Delete</CButton>
                </CRow>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          class="pagination-block"
          :recordPerPage="recordPerPage"
          :currentPage="currentPage"
          :total="total"
          @changePage="changePage"
        />
      </CCol>
    </CRow>
    <add-edit-test
      v-if="addEditTestModal"
      :test="test"
      :action="action"
      :show="addEditTestModal"
      @close="addEditTestModal = false"
      @submit="addEditTest"
      class="modal-width"
    />
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import { mapGetters } from "vuex";
import AddEditTest from "@/views/master/AddEditTest";
export default {
  data() {
    return {
      action: "",
      perPageOptions: [10, 20, 30, 50, 100],
      searchTestTypeOptions: ["Pathology", "Radiology", "All"],
      type: "All",
      recordPerPage: 10,
      search: "",
      currentPage: 1,
      masterTest: [],
      addEditTestModal: false,
      test: {},
      total: 0
    };
  },
  components: {
    AddEditTest,
    pagination: () => import("@/views/common/Pagination"),
    ...pickSvg("crossSVG")
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  watch: {},
  methods: {
    editTestModal(test) {
      this.test = test;
      this.addEditTestModal = true;
    },
    addTestModal() {
      this.test = {
        name: null,
        cost: null,
        report_by_day: null,
        category: "Regular",
        fasting: 0,
        advice: null,
        home_service: 0,
        type: "",
        id: null
      };
      this.addEditTestModal = true;
      this.action = "Add";
    },
    addEditTest(val) {
      let url = `${config.DIAGNOSTICS_URL}api/v1/admin/master-test-add-edit`;
      this.$http.post(url, this.test).then(res => {
        if (res.data.status) {
          this.getMasterTest();
          this.$swal({
            text: "Test " + this.action + " sucessfully",
            icon: "success",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "Ok"
          });
          this.addEditTestModal = false;
        }
      });
    },
    deleteTestModal(val) {
      this.$swal({
        title: "Are you sure?",
        text: "you want to delete this test from master list!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          let url =
            `${config.DIAGNOSTICS_URL}api/v1/admin/master-test-add-edit/` +
            val.id;
          this.$http.delete(url).then(res => {
            if (res.data.status) {
              this.$swal({
                text: "Test Deleted sucessfully",
                icon: "success",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "Ok"
              });
              this.getMasterTest();
            }
          });
        }
      });
    },
    getMasterTest() {
      let url = `${config.DIAGNOSTICS_URL}api/v1/admin/master-test`;
      let payload = {
        search_text: this.search,
        type: this.type,
        page: this.currentPage,
        records_per_page: this.recordPerPage
      };
      this.$http.get(url, { params: payload }).then(res => {
        if (res.body.status) {
          this.masterTest = res.body.data.data;
          this.total = res.body.data.total;
        }
      });
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getMasterTest();
    }
  },
  created() {
    this.getMasterTest();
  }
};
</script>
